const translations = {
  "en": {
    "~Connect your broker and I'll show you how much your funds overlap. Sign in and it's free.~": "~Connect your broker and I'll show you how much your funds overlap. Sign in and it's free.~",
    "~Hi, I'm Ed. Sign in and I'll open up your funds. No forms first.~": "~Hi, I'm Ed. Sign in and I'll open up your funds. No forms first.~",
    "~overlap check~": "~overlap check~",
    "~Your ETFs might be buying the same stocks.~": "~Your ETFs might be buying the same stocks.~",
    "Connect your broker and I'll show you how much your funds overlap. Sign in and it's free.": "Connect your broker and I'll show you how much your funds overlap. Sign in and it's free.",
    "Hi, I'm Ed. Sign in and I'll open up your funds. No forms first.": "Hi, I'm Ed. Sign in and I'll open up your funds. No forms first.",
    "overlap check": "overlap check",
    "Your ETFs might be buying the same stocks.": "Your ETFs might be buying the same stocks."
  },
  "zh-tw": {
    "~Connect your broker and I'll show you how much your funds overlap. Sign in and it's free.~": "連結您的券商帳戶，我將為您顯示持倉重疊程度。登入即可免費使用。",
    "~Hi, I'm Ed. Sign in and I'll open up your funds. No forms first.~": "您好，我是 Ed。登入後，我將為您開啟資金。無需填寫表格。",
    "~overlap check~": "overlap check",
    "~Your ETFs might be buying the same stocks.~": "您的 ETF 可能買進相同的股票。",
    "Connect your broker and I'll show you how much your funds overlap. Sign in and it's free.": "連接您的券商帳戶，Ed 將為您顯示基金重疊程度。登入即可免費使用。",
    "Hi, I'm Ed. Sign in and I'll open up your funds. No forms first.": "您好，我是 Ed。請登入，我將為您開啟資金。無需先填寫表單。",
    "overlap check": "重疊檢查",
    "Your ETFs might be buying the same stocks.": "您持有的 ETF 可能重複買進相同的股票。"
  }
};

export default translations;
